// extracted by mini-css-extract-plugin
module.exports = {"root":"TeNn01fj","subheading":"hF69nHH-","flag":"KTtcqvr4"};